import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Paper, Tab, Tabs, Typography } from "@mui/material";
import RewardTemplateTab from "./RewardTemplateTab";
import IssuedCouponsTab from "./IssuedCouponsTab";
import { canShowPermission } from "../Permissions/permissionObject";

export default function LuckyDrawPage() {
  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = useState(0);
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const stored = localStorage.getItem("userPermissions");
    if (stored) {
      try {
        setPermissions(JSON.parse(stored));
      } catch (error) {
        console.error("Failed to parse userPermissions", error);
      }
    }
  }, []);

  const tabs = [
    canShowPermission(permissions, "rewardTemplate", "view") && {
      label: t("tabs.rewardTemplate"),
      content: <RewardTemplateTab permissions={permissions} />,
    },
    canShowPermission(permissions, "issuedCoupons", "view") && {
      label: t("tabs.issuedCoupons"),
      content: <IssuedCouponsTab />,
    },
  ].filter(Boolean);

  const selected = tabs[tabIndex] ? tabIndex : 0;

  return (
    <Box sx={{ width: "100%", height: "100vh", overflow: "auto" }}>
      <Box
        sx={{
          width: "100%",
          mt: { xs: 10, md: 10 },
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Paper sx={{ p: { xs: 2, sm: 4 }, mb: 2, borderRadius: "16px" }} elevation={1}>
          {tabs.length === 0 ? (
            <Typography>{t("common.permissionDenied")}</Typography>
          ) : (
            <>
              <Tabs
                value={selected}
                onChange={(event, value) => setTabIndex(value)}
                variant="fullWidth"
                sx={{
                  mb: 2,
                  backgroundColor: "#f5f5f5",
                  borderRadius: "8px",
                  padding: "4px",
                  "& .MuiTab-root": {
                    fontWeight: 600,
                    fontSize: "16px",
                    textTransform: "none",
                    borderRadius: "6px",
                    minHeight: "48px",
                    "&.Mui-selected": {
                      backgroundColor: "#fff",
                      color: "#7A3FFF",
                      borderBottom: "3px solid #7A3FFF",
                    },
                  },
                  "& .MuiTabs-indicator": { display: "none" },
                }}
              >
                {tabs.map((tab) => (
                  <Tab key={tab.label} label={tab.label} />
                ))}
              </Tabs>
              <Box>{tabs[selected]?.content}</Box>
            </>
          )}
        </Paper>
      </Box>
    </Box>
  );
}
